<template>
  <div class="meal-tab-page meal-comment-page">
    <van-notice-bar mode="closeable" left-icon="volume-o" v-if="disabled">
      每天17:30～20:00可进行评价
    </van-notice-bar>
    <van-form class="meal-comment" @submit="handleSubmit">
      <van-field
        name="口味"
        label="口味"
        :rules="[{ required: true, message: '请给口味打分' }]"
      >
        <template #input>
          <van-rate v-model="formData.flavour" />
        </template>
      </van-field>
      <van-field
        name="新鲜度"
        label="新鲜度"
        :rules="[{ required: true, message: '请给新鲜度打分' }]"
      >
        <template #input>
          <van-rate v-model="formData.freshness" />
        </template>
      </van-field>
      <van-field
        name="食材分量"
        label="食材分量"
        :rules="[{ required: true, message: '请给食材分量打分' }]"
      >
        <template #input>
          <van-rate v-model="formData.ingredients" />
        </template>
      </van-field>
      <van-field
        name="样式多样性"
        label="样式多样性"
        :rules="[{ required: true, message: '请给样式多样性打分' }]"
      >
        <template #input>
          <van-rate v-model="formData.diversityDishes" />
        </template>
      </van-field>
      <van-field
        name="取餐便捷度"
        label="取餐便捷度"
        :rules="[{ required: true, message: '请给取餐便捷度打分' }]"
      >
        <template #input>
          <van-rate v-model="formData.convenienceEating" />
        </template>
      </van-field>
      <van-field
        name="服务态度"
        label="服务态度"
        :rules="[{ required: true, message: '请给服务态度打分' }]"
      >
        <template #input>
          <van-rate v-model="formData.serviceManner" />
        </template>
      </van-field>
      <van-field
        v-model="formData.advice"
        rows="3"
        autosize
        label="建议"
        type="textarea"
        placeholder="请输入建议"
      />
      <div class="action">
        <van-button
          round
          block
          type="info"
          :disabled="disabled"
          native-type="submit"
        >
          提 交
        </van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import Vue from 'vue';
import * as mealApi from '@api/meal';
import {
  NoticeBar,
  Button,
  Popup,
  Toast,
  Dialog,
  Loading,
  Rate,
  Form,
  Field,
} from 'vant';

// 一次性引入常用组件
[NoticeBar, Button, Popup, Toast, Dialog, Loading, Rate, Form, Field].forEach(
  item => {
    if (item.install) {
      Vue.use(item);
    }
  }
);

export default {
  inject: ['setActive'],
  data() {
    return {
      disabled: true, // 评论是否在允许的时间
      formData: {
        flavour: 0, // 口味
        freshness: 0, // 新鲜度
        ingredients: 0, // 食材分量
        diversityDishes: 0, // 菜式多样性
        convenienceEating: 0, // 取餐便捷度
        serviceManner: 0, // 服务态度
        advice: '', // 建议
        timer: null,
      },
    };
  },
  created() {
    this.setActive('comment');

    this.setDisabled();
    this.timer = setInterval(() => {
      this.setDisabled();
    }, 1000);
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    /**
     * 评价功能只在17:30～20:00可用
     */
    setDisabled() {
      const timeRange = [17 * 60 + 30, 20 * 60];
      this.disabled = !this.$utils.hasInTimeRange(timeRange);
    },
    async handleSubmit() {
      const res = await mealApi.mealAddReview(this.formData).catch(err => {
        Toast.fail(err.message);
      });
      if (res) {
        Toast.success('提交成功！');
      }
    },
  },
};
</script>

<style lang="scss">
.meal-comment {
  .action {
    margin-top: 40px;
    padding: 0 40px;
  }
}
</style>
